import { render, staticRenderFns } from "./app.vue?vue&type=template&id=056050f0"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"
import style0 from "../../assets/styles/common.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "../../assets/styles/tabs.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "./main.scss?vue&type=style&index=2&prod&lang=scss&external"
import style3 from "../../assets/styles/a11yModal.scss?vue&type=style&index=3&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.4_@rspack+core@2.1.1_webpack@5.108.2_postcss@8.5.16___1b790b54f7ec47b93c925242303ba546/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports